module.exports = __webpack_public_path__ + "static/media/oberflex-cheneardoiset308-2560x1440.edc417e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/surfaces/variants/oberflex-cheneardoiset308-2560x1440.jpg
// module id = 997
// module chunks = 37